import * as T_T from 'cryface';
import { cloneDeep } from 'lodash';

export function hybridShareCommunityEduOptions(vs: any) {
    const sum = T_T.sum(vs.Data.map((v: any) => (Number(v['Value']))));
    const data: any = vs.Data.map((v: any) => ({
        name: `${T_T.trunc(v['Key'], 60, '...')}: (${Math.round(Number(v['Value']) / sum * 10000) / 100}%)`,
        value: Number(v['Value']),
        title: `${v['Key']}`,
        share: Math.round(Number(v['Value']) / sum * 10000) / 100
    }));
    const preLegend = data.map((v: any) => (`${v.name}`));
    const legend = preLegend.filter((v: any) => {
        return (preLegend.length - preLegend.indexOf(v)) < 11;
    });
    const lowShare = {
        key: 'low',
        value: Math.round(T_T.sum(data.filter((v: any) => {
            return (v.title.toLowerCase().indexOf('secondary') > -1)
                || v.title.toLowerCase().indexOf('postsecondary') > -1;
        }).map((v: any) => (v.share))))
    };
    const midShare = {
        key: 'average',
        value: Math.round(T_T.sum(data.filter((v: any) => {
            return (v.title.toLowerCase().indexOf('college') > -1)
                || v.title.toLowerCase().indexOf('trades') > -1
                || v.title.toLowerCase().indexOf('apprenticeship') > -1;
        }).map((v: any) => (v.share))),
        )
    };
    const highShare = {
        key: 'high',
        value: Math.round(T_T.sum(data.filter((v: any) => {
            return ((v.title.toLowerCase().indexOf('university certificate, diploma or degree at bachelor level or above') > -1)
                || (v.title.toLowerCase().indexOf(`master's degree`) > -1)
                || (v.title.toLowerCase().indexOf('degree in medicine') > -1)
                || (v.title.toLowerCase().indexOf('earned doctorate') > -1)
                || (v.title.toLowerCase().indexOf(`bachelor's degree`) > -1));
        }).map((v: any) => (v.share)))),
    };
    // const max = cloneDeep(data).sort((a: any, b: any) => b.value - a.value);
    let highestLevel = midShare.value;
    let story = 'Relatively High Level';
    if (lowShare.value > 85) {
        story = 'Mid Level';
        highestLevel = lowShare.value;
    }
    if (midShare.value > 40) {
        story = 'Relatively High Level';
    }
    if (highShare.value > 25) {
        story = 'Extremely High Level';
        highestLevel = highShare.value;
    }
    const options = {
        rifoStory: {
            title: story,
            value: `${highestLevel}%`
        },
        legend: {
            // orient: 'vertical',
            x: 'left',
            data: legend,
            itemWidth: 5,
            textStyle: {
                fontSize: 10,
            },
        },
        series: [
            {
                name: 'age',
                type: 'pie',
                radius: ['60%', '70%'],
                center: ['50%', '72%'],
                data: data,
                label: {
                    normal: {
                        formatter: '{d}%',
                        // formatter: '{b}\r\n({d}%)',
                        position: 'inside',
                        show: false,
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                itemStyle: {
                    emphasis: {
                        // shadowBlur: 10,
                        // shadowOffsetX: 0,
                        // shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };
    return options;
}
